/**
 * Created by quikr on 8/1/16.
 */

import {hashHistory} from "react-router";
import toastr from "toastr";
import * as actionss from "../actionTypes";
import session from "../../../classes/session";
import Auth from "./auth.class";
import {beginAjaxCall} from "../ajaxStatusActions";
import {noError} from "../Errors/errorActions";
import * as actions from "../Attendance/attendanceActions";
import ApiCli from "../../../helpers/ApiCli";

let Ajaxcall = new ApiCli();


export function loginSuccess(Auth) {
  return {type: actionss.STORE_LOGIN_SUCCESS, Auth};

}

export function logOutSuccess(Auth) {
  return {type: 'LOG_OUT_SUCCESS', Auth};
}

export function myQuikrSuccess(Auth) {
  return {type: 'STORE_ROLES_SUCCESS', Auth};
}

export function logOut() {
  return function (dispatch, getState) {
    dispatch(noError());
    dispatch(beginAjaxCall());

    console.log(getState)
    if (getState().auth[0].loggedIn) {

      let call1 = Ajaxcall.asyncAction("/logout", "post", null, null, dispatch);
      call1.then((response) => {

        Auth.loggedIn = false;
        Auth.EmpId = null;
        Auth.roles = {recruitment: {rec: false, ops: false, emp: false, admin: false, it: false}};

        session.logout();

        if (getState().auth[0].loggedIn == true) {
          toastr.success("Logged Out");
        }
        dispatch(logOutSuccess(Auth));
        dispatch(beginAjaxCall());
        dispatch(actions.loadDefaultAttendance());
        dispatch(beginAjaxCall());
        dispatch(actions.loadDefaultTeamAttendance());
        localStorage.setItem('loggedInHRMS', false);
        localStorage.removeItem("checkInTime");
        localStorage.removeItem('state');

        hashHistory.push("/login");
      }).catch((error) => {


      });
    }
  };
}

export function myQuikr() {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    Auth.loggedIn = true;
    Auth.EmpId = getState().auth[0].EmpId;
    Auth.roles = {recruitment: {rec: true, ops: true, emp: true, admin: true, it: true}};
    dispatch(myQuikrSuccess(Auth));
  };
}

export function login(login, toggle) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let call1 = Ajaxcall.asyncAction("/login", 'post', null, login, dispatch);
    call1.then((response)=> {
      toggle();

      Auth.loggedIn = true;
      Auth.EmpId = login.email;
      localStorage.setItem('loggedInHRMS', true);
      session.login(Auth.loggedIn, Auth.roles);

      dispatch(loginSuccess(Auth));
      toastr.success('Successfully Logged in!');
      hashHistory.push('/1');
      window.history.pushState('mainPage', 'Title', '/#/1');


    }).catch(function (error) {
      toggle();

      /* eslint-disable no-console*/
      if (error.response != undefined) {

        toastr.error(error.response);
        hashHistory.push('/invalidEmail');
        window.history.pushState('invalidEmail', 'Title', '/#/invalidEmail');
      }

    });
  };
}




/** WEBPACK FOOTER **
 ** ./src/redux/actions/Authentication/authActions.js
 **/